module.exports = __webpack_public_path__ + "static/media/LastIsland.6857b665.png";